// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttonStyles-cls1___560607ee60600b1edf9{/*!*/}.buttonStyles-cls2___75d4ff80d835b6ea1a2{position:relative;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "buttonStyles-cls1___560607ee60600b1edf9",
	"cls2": "buttonStyles-cls2___75d4ff80d835b6ea1a2 buttonStyles-cls1___560607ee60600b1edf9"
};
export default ___CSS_LOADER_EXPORT___;
